/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Updatedat1Inputs */

const id_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperbarui Pada`)
};

const ms_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikemas Kini Pada`)
};

const da_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdateret`)
};

const de_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert am`)
};

const en_us2_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated At`)
};

const es_es2_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizada el`)
};

const es_mx2_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizada el`)
};

const fil_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-update Noong`)
};

const fr_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour le`)
};

const it_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornata il`)
};

const hu_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frissítve`)
};

const nl_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijgewerkt op`)
};

const no_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppdatert`)
};

const pl_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaktualizowano`)
};

const pt_br2_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado em`)
};

const pt_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizada em`)
};

const ro_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizată la`)
};

const fi_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitetty`)
};

const sv_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdaterad`)
};

const vi_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật lúc`)
};

const tr_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncellenme`)
};

const cs_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizováno`)
};

const bg_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актуализирано на`)
};

const ru_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлена`)
};

const uk_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновлено`)
};

const ar_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ التحديث`)
};

const hi_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट तिथि`)
};

const th_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตเมื่อ`)
};

const ja_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日`)
};

const zh_cn2_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日期`)
};

const zh_hant1_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日期`)
};

const ko_builds_table_updatedat1 = /** @type {(inputs: Builds_Table_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트일`)
};

/**
* | output |
* | --- |
* | "Updated At" |
*
* @param {Builds_Table_Updatedat1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_updatedat1 = /** @type {((inputs?: Builds_Table_Updatedat1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Updatedat1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_updatedat1(inputs)
	if (locale === "ms") return ms_builds_table_updatedat1(inputs)
	if (locale === "da") return da_builds_table_updatedat1(inputs)
	if (locale === "de") return de_builds_table_updatedat1(inputs)
	if (locale === "en-US") return en_us2_builds_table_updatedat1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_updatedat1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_updatedat1(inputs)
	if (locale === "fil") return fil_builds_table_updatedat1(inputs)
	if (locale === "fr") return fr_builds_table_updatedat1(inputs)
	if (locale === "it") return it_builds_table_updatedat1(inputs)
	if (locale === "hu") return hu_builds_table_updatedat1(inputs)
	if (locale === "nl") return nl_builds_table_updatedat1(inputs)
	if (locale === "no") return no_builds_table_updatedat1(inputs)
	if (locale === "pl") return pl_builds_table_updatedat1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_updatedat1(inputs)
	if (locale === "pt") return pt_builds_table_updatedat1(inputs)
	if (locale === "ro") return ro_builds_table_updatedat1(inputs)
	if (locale === "fi") return fi_builds_table_updatedat1(inputs)
	if (locale === "sv") return sv_builds_table_updatedat1(inputs)
	if (locale === "vi") return vi_builds_table_updatedat1(inputs)
	if (locale === "tr") return tr_builds_table_updatedat1(inputs)
	if (locale === "cs") return cs_builds_table_updatedat1(inputs)
	if (locale === "bg") return bg_builds_table_updatedat1(inputs)
	if (locale === "ru") return ru_builds_table_updatedat1(inputs)
	if (locale === "uk") return uk_builds_table_updatedat1(inputs)
	if (locale === "ar") return ar_builds_table_updatedat1(inputs)
	if (locale === "hi") return hi_builds_table_updatedat1(inputs)
	if (locale === "th") return th_builds_table_updatedat1(inputs)
	if (locale === "ja") return ja_builds_table_updatedat1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_updatedat1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_updatedat1(inputs)
	return ko_builds_table_updatedat1(inputs)
});
export { builds_table_updatedat1 as "builds.table.updatedAt" }